import { render } from "./MassUpdateModal.vue?vue&type=template&id=0e1aa6e1"
import script from "./MassUpdateModal.vue?vue&type=script&lang=js"
export * from "./MassUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__